import { gsap, ScrollTrigger } from 'gsap/all'
gsap.registerPlugin(ScrollTrigger)

export function orb(orb: HTMLElement) {
  const parentSection = orb.closest('section')

  let mm = gsap.matchMedia()

  mm.add('(min-width: 769px)', () => {
    function magneticEnter(e: any) {
      // find x and y position relative to the parent section
      const boundingRect = orb.getBoundingClientRect()
      let relX = e.pageX - (boundingRect.left + boundingRect.width / 2)
      let relY = e.pageY - (boundingRect.top + boundingRect.height / 2)

      gsap.to(orb, {
        x: relX * 0.1,
        y: relY * -0.01,
        ease: 'power1',
        duration: 0.6
      })
    }

    // chnaging info

    function magneticLeave(e: Event) {
      gsap.to(orb, {
        x: 0,
        y: 0,
        ease: 'expo.out',
        duration: 1.2
      })
    }

    // when scrolling into section autoAlpha in orbs using scroltrigger

    ScrollTrigger.create({
      trigger: parentSection,
      start: 'top 50%',
      end: 'bottom 50%',
      onEnter: () => {
        gsap.to(orb, {
          autoAlpha: 1,
          ease: 'expo.out',
          duration: 1.2
        })
      },
      onLeaveBack: () => {
        gsap.to(orb, {
          autoAlpha: 0,
          ease: 'expo.out',
          duration: 1.2
        })
      }
    })

    if (parentSection) {
      parentSection.addEventListener('mousemove', magneticEnter)
      parentSection.addEventListener('mouseleave', magneticLeave)
    }
  })
}
